module.exports = __webpack_public_path__ + "static_portal/img/gym-workout-treadmill.d37947d7.svg";